export default {"src":"/research/_next/static/media/sportsbookLogo.37db1646.svg","height":30,"width":196,"blurWidth":0,"blurHeight":0};